"use client";
import React from "react";
import { Button as AntButton } from "antd";

// wrapper
const Button = ({ children, type = "default", onClick, icon, ...props }) => {
  return (
    <AntButton type={type} onClick={onClick} icon={icon} {...props}>
      {children}
    </AntButton>
  );
};

export default Button;
export { Button };